export default function LoadingState() {
  return <div className="mx-auto max-w-6xl animate-pulse px-4 py-16"><div className="h-8 w-56 rounded bg-slate-200" /><div className="mt-8 grid gap-6 md:grid-cols-3">{[1, 2, 3].map(i => <div key={i} className="h-64 rounded-2xl bg-slate-200" />)}</div></div>;
}